export const RecoveryEmailErrorCodes = {
  'lumiq.account_recovery.recovery_email_addition.user_id_been_removed':
    'This account has been removed',
  'lumiq.account_recovery.recovery_email_addition.already_added':
    'Recovery email already exists',
  'lumiq.account_recovery.recovery_email_addition.already_recovery_email_of_another_user':
    'This email is already used for another account',
  'lumiq.account_recovery.recovery_email_addition.already_identity_email':
    'Please use a different email address for your recovery email',
  'lumiq.account_recovery.recovery_email_addition.already_identity_email_of_another_user':
    'This email is already used for another account',
  'lumiq.account_recovery.recovery_email_addition_verification.verification_code_does_not_exist':
    'This verification code does not exist',
  'lumiq.account_recovery.recovery_email_addition_verification.verification_code_has_already_been_used':
    'This verification code has already been used',
  'lumiq.account_recovery.recovery_email_addition_verification.recovery_email_addition_attempt_no_longer_valid':
    'This verification code is no longer valid',
  'lumiq.account_recovery.archive_recovery_email.no_recovery_email_for_user':
    'Recovery email does not exist',
} as const;
